import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { merge } from 'es-toolkit';
import {tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {BaseService} from '../../../../shared/src/lib/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class FUDSService extends BaseService {
  public item: any = {};
  public meta: any = {};

  constructor(http: HttpClient) {
    super(`${environment.baseUrl}/fuds/attributes`, http);
  }

  public loadData(searchObj) {
    return this.getList(searchObj).pipe(tap(response => {
      if (response.results[0]) {
        merge(this.item, response.results[0]);
      } else {
        this.item = {};
      }

      merge(this.meta, response.meta);
      this.meta.display_fields = [];
      this.meta.type = 'fuds/attributes';
      this.meta.urlPath = 'fuds';
      this.meta.subItems = ['attachments'];
      this.meta.fields.attachments = {type: 'fuds/attachments'};
    }));
  }

}
